import { useRef, useEffect } from "react";
export default function Table({
  columns,
  rows,
  onEdit,
  onDelete,
  onCustomFunction,
  customFunctionName,
  customFunctionShow,
  onCustomFunction2,
  customFunctionName2,
  customFunctionShow2,
  notFoundMessage,
  bigColumn,
  selectable = false,
  selectedIds,
  onSelectionChange,
}) {
  const allIds = rows.map((r) => r.id ?? r.key ?? r._id);
  const selectedCount = selectable ? allIds.filter((id) => selectedIds?.has(String(id))).length : 0;
  const isAllSelected = rows.length > 0 && selectedCount === rows.length;
  const isIndeterminate = selectedCount > 0 && selectedCount < rows.length;

  const selectAllRef = useRef(null);
  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  const handleSelectAll = (e) => {
    if (!onSelectionChange) return;
    if (e.target.checked) {
      onSelectionChange(new Set(allIds.map(String)));
    } else {
      onSelectionChange(new Set());
    }
  };

  const handleSelectRow = (id) => {
    if (!onSelectionChange || !selectedIds) return;
    const strId = String(id);
    const next = new Set(selectedIds);
    if (next.has(strId)) {
      next.delete(strId);
    } else {
      next.add(strId);
    }
    onSelectionChange(next);
  };

  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-6">
      {rows.length > 0 ? (
        <table className="w-full max-h-[1024px] overflow-y-scroll text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-md text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              {selectable && (
                <th scope="col" className="px-4 py-3 w-10">
                  <input
                    ref={selectAllRef}
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                    className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                  />
                </th>
              )}
              {columns &&
                columns.map((item, index) => (
                  <th key={index} scope="col" className={`px-6 py-3 ${bigColumn ? "min-w-40" : null}`}>
                    {item.title}
                  </th>
                ))}
              {(onEdit || onDelete || onCustomFunction || onCustomFunction2) && (
                <th scope="col" className="px-6 py-3">
                  عملیات
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {rows &&
              rows.map((item, index) => {
                const rowId = String(item.id ?? item.key ?? item._id);
                const isChecked = selectable && !!selectedIds?.has(rowId);
                return (
                  <tr
                    key={index}
                    className={`border-b dark:border-gray-700 transition-colors ${
                      isChecked
                        ? "bg-blue-50 dark:bg-blue-900/20"
                        : "odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800"
                    }`}
                  >
                    {selectable && (
                      <td className="px-4 py-4 w-10">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => handleSelectRow(rowId)}
                          className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                        />
                      </td>
                    )}
                    {columns.map((ColItem, index) => (
                      <td key={index} className="px-6 py-4">
                        {ColItem.render
                          ? ColItem.render(item)
                          : item[`${ColItem.value}`]}
                      </td>
                    ))}
                    {(onEdit || onDelete || onCustomFunction || onCustomFunction2) && (
                      <td className="px-6 py-4 flex item-center gap-x-2">
                        {onEdit && (
                          <p
                            onClick={() => onEdit(item)}
                            className="font-medium cursor-pointer text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            ویرایش
                          </p>
                        )}

                        {onCustomFunction &&
                          (!customFunctionShow || customFunctionShow(item)) && (
                            <p
                              onClick={() => onCustomFunction(item)}
                              className="font-medium cursor-pointer text-green-600 dark:text-green-500 hover:underline"
                            >
                              {customFunctionName || "عملیات"}
                            </p>
                          )}

                        {onCustomFunction2 &&
                          (!customFunctionShow2 || customFunctionShow2(item)) && (
                            <p
                              onClick={() => onCustomFunction2(item)}
                              className="font-medium cursor-pointer text-indigo-600 dark:text-indigo-500 hover:underline"
                            >
                              {customFunctionName2 || "عملیات 2"}
                            </p>
                          )}

                        {onDelete && (
                          <p
                            onClick={() => onDelete(item)}
                            className="font-medium cursor-pointer text-red-600 dark:text-red-500 hover:underline"
                          >
                            حذف
                          </p>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      ) : (
        <div className="py-3 flex w-full justify-center dark:text-white">
          <p>{notFoundMessage || "هیچ دیتایی وجود ندارد"}</p>
        </div>
      )}
    </div>
  );
}
